export function SET_QR_TO_PRINT(state, value) {
  state.qrToPrint = value;
}
